import React, { useState } from "react";
import PropTypes from "prop-types";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import styles from "./SingleDatePicker.module.scss";

export const SingleDatePicker = ({
  selectedDate,
  onDateChange,
  label = "Select a date",
  placeholder = "DD/MM/YYYY",   // Display placeholder in DD/MM/YYYY format
  dateFormat = "dd/MM/yyyy",  // Changed to match placeholder format
  datePickerClass = '',
  minDate,                      // Minimum allowed date
  maxDate,                      // Maximum allowed date
  yearDropdownItemNumber = 100,   // Default number of items for the year dropdown
}) => {
  // const [selectedDateValue, setSelectedDateValue] = useState(null)
  // if(selectedDate){
  //   setSelectedDateValue()
  // }
  const [isFocused, setIsFocused] = useState(false);

  const handleFocus = () => setIsFocused(true);
  const handleBlur = () => setIsFocused(false);

  return (
    <div className={`${styles.datePickerContainer} ${datePickerClass}`}>
      <label
        className={`${styles.floatingLabel} ${
          isFocused || selectedDate ? styles.floating : ""
        }`}
      >
        {label}
      </label>
      <DatePicker
        selected={selectedDate}
        onChange={(date) => onDateChange(date)}
        dateFormat={dateFormat}
        placeholderText={placeholder}
        onFocus={handleFocus}
        onBlur={handleBlur}
        calendarClassName={styles.customCalendar}
        wrapperClassName={styles.datePickerWrapper}
        popperProps={{
          positionFixed: true
        }}
        showYearDropdown                 // Enable year dropdown for easier date selection
        showMonthDropdown                // Enable month dropdown
        scrollableYearDropdown           // Allow scrolling in the year dropdown
        yearDropdownItemNumber={yearDropdownItemNumber}
        minDate={minDate}                // Min date prop to restrict date selection
        maxDate={maxDate}                // Max date prop to restrict date selection
        autoComplete="off"
        dayClassName={(date) =>
          date.getTime() === (selectedDate && selectedDate.getTime())
            ? styles.customSelected
            : styles.customDay
        }
      />
    </div>
  );
};

SingleDatePicker.propTypes = {
  selectedDate: PropTypes.instanceOf(Date),
  onDateChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  dateFormat: PropTypes.string,
  datePickerClass: PropTypes.string,
  minDate: PropTypes.instanceOf(Date),    // Prop for minimum allowed date
  maxDate: PropTypes.instanceOf(Date),    // Prop for maximum allowed date
  yearDropdownItemNumber: PropTypes.number,
};
